import * as types from '../actionTypes';

const initialState = {
    businessname:'',
    phoneNumber:'',
    whatsapp:'',
    location:'',
    facebook:'',
    instagram:'',
    about:'',
    openingHours:'',
    servicesDescription:'',
    status: 'NEW'
  }

const clientInfoReducer = (state = initialState ,action) => {

    switch(action.type){

        case types.editClientInfo:
            return {
                ...state,
                [action.payload.property]:action.payload.value
            }

        default:
            return state;
    }
    
}

export default clientInfoReducer;